const TEST_IDS = {
  selectCollateralTokenTextField: 'select-collateral-token-text-field',
  selectRepaidTokenTextField: 'select-repaid-token-text-field',
  availableAmount: 'available-amount',
};

export default TEST_IDS;
